
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as item1IaLrWOngUn1V9gXxyuSqqXUea_45_4531LrBa3_45IUci3DX8Meta } from "/opt/buildhome/repo/pages/item1.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as sandboxhzNMMaYVysAOO94O8YmotC8_yncS3zfmY2Txr_QQnloMeta } from "/opt/buildhome/repo/pages/sandbox.vue?macro=true";
import { default as settingsXxHd4Gbotd8GwcMHWDBbPo2R_452rFtc31BzCyJeZgaf0Meta } from "/opt/buildhome/repo/pages/settings.vue?macro=true";
import { default as _91industry_93CfjGgQmgByIliu_45dhRyCRHfy0aKrH3fNyUs8VvgicxIMeta } from "/opt/buildhome/repo/pages/[industry].vue?macro=true";
import { default as admin_32copyVpAcSSGFJcqYi0iSFdNVLxE2emU8XTCIFWWGjQfMne0Meta } from "/opt/buildhome/repo/pages/admin copy.vue?macro=true";
import { default as indexLpA_45enE7H_45gCt1CVZrtW6_TonNg0AO233DpYOSBdY68Meta } from "/opt/buildhome/repo/pages/admin/index.vue?macro=true";
import { default as data_45uploadS11n0izKmZebebPVMx_45_pz3W7Bq_1XNNUtS_j1YqthUMeta } from "/opt/buildhome/repo/pages/admin/data-upload.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "item1",
    path: "/item1",
    component: () => import("/opt/buildhome/repo/pages/item1.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "sandbox",
    path: "/sandbox",
    component: () => import("/opt/buildhome/repo/pages/sandbox.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/opt/buildhome/repo/pages/settings.vue")
  },
  {
    name: "industry",
    path: "/:industry()",
    meta: _91industry_93CfjGgQmgByIliu_45dhRyCRHfy0aKrH3fNyUs8VvgicxIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[industry].vue")
  },
  {
    name: "admin copy",
    path: "/admin%20copy",
    component: () => import("/opt/buildhome/repo/pages/admin copy.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/opt/buildhome/repo/pages/admin/index.vue")
  },
  {
    name: "admin-data-upload",
    path: "/admin/data-upload",
    component: () => import("/opt/buildhome/repo/pages/admin/data-upload.vue")
  }
]